import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getProductCategoriesForCustomerPortalQuery: DocumentNode = gql`
  query GetProductCategoriesForCustomerPortal($isOther: Boolean!) {
    productCategoriesForCustomerPortal(isOther: $isOther) {
      id,
      name,
      packageWeight,
      isOther,
      invoiceValue,
      commodityCode
    }
  }
`;
